import * as libphonenumber from "libphonenumber-js"
import {t} from "@lingui/core/macro"
import {getCountry} from "../../components/permissions/functions";
import COUNTRY from "country-json/src/country-by-abbreviation.json";
import {Tag} from "antd";
import React from "react";


export function contactFormatTel(tel,defaultCountry="FR")
{
    if(!tel){
        return tel
    }

    return new libphonenumber.AsYouType(defaultCountry).input(tel)
}

export function contactToCapitalize(text="")
{
    if(!text){
        return text
    }
    return String(text).charAt(0).toUpperCase() + String(text).slice(1)?.toLowerCase()
}


export function contactCopie(text=""){
    navigator.clipboard.writeText(text)
        .then(() => console.log("Copié !"))
        .catch(err => console.error("Erreur de copie", err));
}

export function ContactFormatFamilyLink(type, homme = null) {
    let text = "";

    switch (type) {
        case "PERE":
            text = t`Père / Mère`;
            if (homme === true) text = t`Père`;
            if (homme === false) text = t`Mère`;
            return <Tag color="green">{text}</Tag>;

        case "MARI":
            text = t`Conjoint / Conjointe`;
            if (homme === true) text = t`Conjoint`;
            if (homme === false) text = t`Conjointe`;
            return <Tag color="orange">{text}</Tag>;

        case "ENFANT":
            text = t`Enfant`;
            if (homme === true) text = t`Fils`;
            if (homme === false) text = t`Fille`;
            return <Tag color="blue">{text}</Tag>;

        case "FRERE":
            text = t`Frère / Sœur`;
            if (homme === true) text = t`Frère`;
            if (homme === false) text = t`Sœur`;
            return <Tag color="blue">{text}</Tag>;

        case "GP":
            text = t`Grand Père / Grand Mère`;
            if (homme === true) text = t`Grand Père`;
            if (homme === false) text = t`Grand Mère`;
            return <Tag color="green">{text}</Tag>;

        case "PF":
            text = t`Petit Fils / Petite Fille`;
            if (homme === true) text = t`Petit Fils`;
            if (homme === false) text = t`Petite Fille`;
            return <Tag color="blue">{text}</Tag>;

        case "EX":
            text = t`Ex Conjoint / Ex Conjointe`;
            if (homme === true) text = t`Ex Conjoint`;
            if (homme === false) text = t`Ex Conjointe`;
            return <Tag color="purple">{text}</Tag>;

        case "BF":
            text = t`Beau Frère / Belle Sœur`;
            if (homme === true) text = t`Beau Frère`;
            if (homme === false) text = t`Belle Sœur`;
            return <Tag color="purple">{text}</Tag>;

        case "COUSIN":
            text = t`Cousin / Cousine`;
            if (homme === true) text = t`Cousin`;
            if (homme === false) text = t`Cousine`;
            return <Tag color="purple">{text}</Tag>;

        case "AMI":
            text = t`Ami / Amie`;
            if (homme === true) text = t`Ami`;
            if (homme === false) text = t`Amie`;
            return <Tag color="purple">{text}</Tag>;

        default:
            return null;
    }
}

export function getContactTels(selected)
{
    let tels=[]
    let i=0

    if(selected.tel){
        i++
        tels.push({
            id:null,
            title:selected?.telLabel || t`Tel. Principal`,
            type:selected?.telLabel || t`Tel. Principal`,
            number:selected.tel,
            formatedNumber:contactFormatTel(selected.tel),
            adresseId:selected?.telAdresseId || null,
            main:true,
        });
    }

    for(let item of selected.tels){
        i++
        tels.push({
            id:item.id,
            title:item.type || t`Tel. ${i}`,
            type:item.type || t`Tel. ${i}`,
            number:item.number,
            formatedNumber:contactFormatTel(item.number),
            adresseId:item.adresseId || null,
        })
    }

    return tels
}


export function getContactEmails(selected)
{
    let tels=[]
    let i=0

    if(selected.email){
        i++
        tels.push({
            id:null,
            title:selected?.emailLabel ||t`Email Principal`,
            type:selected?.emailLabel ||t`Email Principal`,
            email:selected.email,
            adresseId:selected?.emailAdresseId || null,
            main:true
        });
    }

    for(let item of selected.emails){
        i++
        tels.push({
            id:item.id,
            title:item.type || t`Email. ${i}`,
            type:item.type || t`Email. ${i}`,
            email:item.email,
            adresseId:selected?.telAdresseId || null,
        })
    }

    return tels
}

export function getContactAdresses(selected)
{
    let adresses=[]
    let i=0

    if(selected.adresse){
        i++
        const main={
            main:true,
            id:"MAIN",
            nom:selected?.adresseNom || t`Adresse Principale`,
            adresse:selected.adresse,
            siren: null,
            postal: selected.postal,
            ville: selected.ville,
            pays: selected.pays || COUNTRY.find(i=>i.abbreviation===getCountry())?.country,
            note_adresse: selected.note_adresse,
        }
        main.fullAdresse=(main.adresse+" "+main.postal+" "+main.ville+" "+main.pays).replaceAll("undefined","").trim()
        adresses.push(main);
    }

    for(let item of selected.adresses){
        i++
        const object={
            id:item.id,
            nom:item.nom || t`Adresse ${i}`,
            adresse:item.adresse,
            siren: item.siren,
            postal: item.postal,
            ville: item.ville,
            pays: item.pays || COUNTRY.find(i=>i.abbreviation===getCountry())?.country,
            note_adresse: item.note_adresse,
        }

        if(object.siren){
            object.fullAdresse=(object.nom+" "+object.adresse+" "+object.postal+" "+object.ville+" "+object.pays).replaceAll("undefined","").trim()
        }else{
            object.fullAdresse=(object.adresse+" "+object.postal+" "+object.ville+" "+object.pays).replaceAll("undefined","").trim()
        }

        adresses.push(object);
    }

    return adresses
}
